import { Link } from "react-router-dom";
import Icon from "../../../components/AppIcon";

const Footer = () => {
  const currentYear = new Date()?.getFullYear();

  const footerLinks = {
    navigation: [
      { label: "Home", path: "/homepage" },
      { label: "Projects", path: "/projects" },
      { label: "Skills", path: "/skills" },
      { label: "Blog", path: "/blog" },
    ],
    connect: [
      { label: "Collaboration", path: "/collaboration" },
      { label: "Contact", path: "/contact" },
    ],
  };

  return (
    <footer className="bg-surface border-t border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          <div className="lg:col-span-2">
            <Link to="/homepage" className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 bg-primary rounded-lg flex items-center justify-center">
                <span className="text-primary-foreground font-mono font-bold text-lg">MFA</span>
              </div>
              <div>
                <div className="font-bold text-foreground text-lg">Muhammad Fotih Abdullaev</div>
                <div className="text-xs text-muted-foreground font-mono">&lt;Developer /&gt;</div>
              </div>
            </Link>
            <p className="text-muted-foreground mb-4 max-w-md">
              Computer Science student at Valencia College, passionate about building innovative solutions and collaborating on meaningful projects.
            </p>
            <div className="flex items-center gap-2 text-sm text-muted-foreground">
              <Icon name="MapPin" size={16} />
              <span>Orlando, Florida</span>
            </div>
          </div>

          <div>
            <h3 className="font-semibold text-foreground mb-4">Navigation</h3>
            <ul className="space-y-2">
              {footerLinks?.navigation?.map((link) => (
                <li key={link?.path}>
                  <Link
                    to={link?.path}
                    className="text-muted-foreground hover:text-primary transition-colors duration-300"
                  >
                    {link?.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-semibold text-foreground mb-4">Connect</h3>
            <ul className="space-y-2">
              {footerLinks?.connect?.map((link) => (
                <li key={link?.path}>
                  <Link
                    to={link?.path}
                    className="text-muted-foreground hover:text-primary transition-colors duration-300"
                  >
                    {link?.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-border flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-muted-foreground">
            © {currentYear} Muhammad Fotih Abdullaev. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a
              href="https://github.com/Muhammadninja?tab=repositories/Muhammadninja?tab=repositories"
              target="_blank"
              rel="noopener noreferrer"
              className="text-muted-foreground hover:text-primary transition-colors duration-300"
              aria-label="GitHub Profile"
            >
              <Icon name="Github" size={20} />
            </a>
            <a
              href="https://www.linkedin.com/in/fotih-abdullaev-901817356/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-muted-foreground hover:text-primary transition-colors duration-300"
              aria-label="LinkedIn Profile"
            >
              <Icon name="Linkedin" size={20} />
            </a>
            <a
              href="https://x.com/muhammad640961?s=21"
              target="_blank"
              rel="noopener noreferrer"
              className="text-muted-foreground hover:text-primary transition-colors duration-300"
              aria-label="Twitter Profile"
            >
              <Icon name="Twitter" size={20} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;